<template lang="pug">
	section.calories-container
		.title-section Calculadora de calorias (kg)
		.content-form
			.subtitle Edad
			input(type="number", v-model="age", min="0", max="130")
			.subtitle Sexo
			.content-input
				.field
					input.is-checkradio.is-dark#fem(type="radio", v-model="sex", :value="true")
					label(for="fem") Femenino				
					input.is-checkradio.is-dark#mas(type="radio", v-model="sex", :value="false")
					label(for="mas") Masculino
			.subtitle Estatura (cm)
			input(type="number", v-model="h", min="0")
			.subtitle Peso (kg)
			input(type="number", v-model="w", min="0")
			.subtitle Actividad
			.content-select
				select(v-model="activity")
					option(v-for="(option, index) in options", :key="index", :value="option.id") {{ option.name }}
			.results
				.info-result Calorias Diarias Necesarias Para Mantener Su Peso:
				.ims-result {{ caloriesByDay }}
				.info-result Calorias Diarias Necesarias Para Perder 1 Libra a la semana:
				.ims-result {{ caloriesLosePound }}
				.info-result Calorias Diarias Necesarias Para Subir 1 Libra a la semana:
				.ims-result {{ caloriesWinPound }}
			.note Nota: la determinación precisa de las calorías que quema solo se puede lograr mediante pruebas fisiológicas individuales
</template>

<script>
import "bulma-checkradio";

export default {
  data() {
    return {
      age: 25,
      w: 60,
      h: 180,
      sex: true,
      options: [
        { id: 1, name: "Poco o ningún ejercicio" },
        { id: 2, name: "Ejercicio ligero (1-3 días a la semana)" },
        { id: 3, name: "Ejercicio moderado (3-5 días a la semana)" },
        { id: 4, name: "Deportista (6-7 días a la semana)" },
        { id: 5, name: "Atleta (dos veces al día, entrenamientos muy duros)" }
      ],
      activity: 1
    };
  },
  computed: {
    caloriesLosePound() {
      let c =
        parseFloat(this.caloriesByDay) - parseFloat(this.caloriesByDay * 0.15);
      return c.toFixed(0);
    },
    caloriesWinPound() {
      console.log(this.caloriesByDay * 0.15);
      let c =
        parseFloat(this.caloriesByDay) + parseFloat(this.caloriesByDay * 0.15);
      return c.toFixed(0);
    },
    caloriesByDay() {
      let c = 10 * this.w + 6.25 * this.h - 5 * this.age;
      let result = 0;
      if (!this.sex) {
        result = c + 5;
      } else {
        result = c - 161;
      }

      switch (this.activity) {
        case 1:
          result *= 1.2;
          break;
        case 2:
          result *= 1.375;
          break;
        case 3:
          result *= 1.55;
          break;
        case 4:
          result *= 1.725;
          break;
        case 5:
          result *= 1.9;
          break;
      }
      return result.toFixed(0);
    }
  }
};
</script>
